const article = {
	slug: "half-life-of-innovation-hoa-chatbot",
	title: "Vemödalen and the Half-Life of Innovation",
	date: "September 2025",
	updated: null,
	description: "A personal HOA email chatbot felt obsolete within weeks when a major browser shipped the same feature, a lesson in the collapsing half-life of innovation.",
	keywords: ["half-life of innovation", "vemödalen", "AI-first", "building", "obsolescence"],
	tldr: "In an AI-first world the half-life of innovation is collapsing. The hard part is not building fast. It is creating value that lasts once the novelty fades.",
	readingTime: null,
	provenance: "Adapted from my LinkedIn post, September 2025.",
	provenanceUrl: null,
	series: null,
	artifact: null,
	markdown: `Vemödalen and the half-life of innovation. That strange frustration when every "new" idea has already been done before.

A few weeks ago, I built a chatbot to solve a personal problem. My Gmail inbox was flooded with HOA emails: pool schedules, roadwork updates, board notices. Finding one piece of info meant endless digging.

So I built a bot that filtered HOA emails and let me ask questions like "When does the pool open?" or "What's the latest on roadwork?" It summarized my HOA emails and answered questions in plain English.

Then last week, Comet browser from Perplexity released an AI assistant that does almost the same thing, built right into Gmail and browsing. Their assistant pulls insights straight from the inbox.

And just like that, my project already felt obsolete.

That's the reality of AI right now. The half-life of innovation is collapsing. What feels new today becomes baseline tomorrow.

The challenge is not building fast. It is enduring. The question shifts from *what can I build next?* to *how can I keep creating value once the novelty fades?*

That's the frontier in this era of vemödalen.`,
};

export default article;
